export default __webpack_public_path__ + "static/media/filled_circle_primary.0c861004.svg";